import { redirect } from "react-router"
import { useUserInfoStore, useEthereumStore } from "../../state"

export const loader = async () => {
  const userInfo = await useUserInfoStore.getState().getOrFetch()

  if (userInfo?.wallet) {
    const walletState = await useEthereumStore.getState().getOrFetch()
    if (walletState.isConnected) {
      return redirect("/dashboard")
    }
    return redirect("/connect-wallet")
  }

  return null
}
